exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".amplily--widget .am-storyline{margin-top:10px!important}", ""]);
